<script lang="ts">
    import type {LayoutRowPartWidth} from 'shared/layouts/grid-system/built-layout/types';
    import type {Px} from 'shared/ui-widgets/types';
    import {createGridSystemRowContext, getGridSystemContext} from 'shared/layouts/grid-system/grid-system-context';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {getLogger} from 'core/svelte-context/context';

    export let columnRatios: number[];
    export let width: LayoutRowPartWidth | null = null;
    export let horizontalGap: Px | null = null;

    let htmlElement: HTMLElement;

    const logger = getLogger();
    const gridContext = getGridSystemContext();
    createGridSystemRowContext(columnRatios);

    onMount(() => {
        if (!exists(htmlElement)) {
            return;
        }

        const columnsCount = htmlElement.children.length;

        if (columnsCount > columnRatios.length) {
            logger.warn(`This row has number of columns defined to ${columnRatios.length}, but there seem to be ${columnsCount} column components inside of its slot.`);
        }
    });

    function getGridTemplate(): string {
        return `${columnRatios.join('fr ')}fr`;
    }
</script>

<div class="kp-row row-width-{width ?? gridContext.rowWidth}"
     bind:this={htmlElement}
     style:--columns-template="{getGridTemplate()}"
     style:--horizontal-gap="{horizontalGap}">

    <slot/>
</div>

<style lang="less">
    @import (reference) "src/shared/layouts/grid-system/grid-system";

    .kp-row {
        display: grid;
        grid-template-columns: var(--columns-template);
        gap: var(--horizontal-gap);
        margin: 0 auto;
        // Needed for proper sizing
        min-width: 0;
        min-height: 0;
    }

    :global {
        .kp-row {
            &.row-width-default {
                width: 100%;

                @media (max-width: @grid-default-mobile-max) {
                    display: flex;
                    flex-direction: column;
                    padding: 0 15px;
                }

                @media (min-width: @grid-default-small-min) {
                    width: 92.5%;
                }


                @media (min-width: @grid-default-medium-min) {
                    width: 90%;
                }

                @media (min-width: @grid-default-large-min) {
                    width: 1140px;
                }
            }

            &.row-width-wide {
                width: 100%;

                @media (max-width: @grid-wide-mobile-max) {
                    display: flex;
                    flex-direction: column;
                    padding: 0 15px;
                }

                @media (min-width: @grid-wide-xs-min) {
                    width: 92.5%;
                }

                @media (min-width: @grid-wide-small-min) {
                    width: 90%;
                }

                @media (min-width: @grid-wide-medium-min) {
                    width: 1140px;
                }

                @media (min-width: @grid-wide-large-min) {
                    width: 1540px;
                }
            }

            &.row-width-fullscreen {
                width: 100%;
                padding: 0 15px;

                @media (min-width: @grid-wide-small-min) {
                    padding: 0 20px;
                }

                @media (min-width: @grid-wide-medium-min) {
                    padding: 0 25px;
                }

                @media (min-width: @grid-wide-large-min) {
                    padding: 0 30px;
                }
            }
        }
    }
</style>